/**
 * Ellipsis in the MIDDLE of a long label (round B U6 / U30): names that share a long prefix ("Contoso (key, read-only)",
 * "Contoso (SAS, orders)") stay distinguishable because their ends stay visible. The head truncates with an ellipsis,
 * the tail (the last `tail` characters) never shrinks, and the full text is the tooltip. Short labels render as one
 * plain truncating span, so their text node — and every locator on it — is unchanged.
 */
import { cn } from '../../lib/utils';

type Props = { text: string; tail?: number; className?: string; title?: string };

export function MiddleTruncate({ text, tail = 10, className, title = text }: Props) {
  // Z9 (last UI/UX pass): block-level, so the truncation box is the parent's width — an inline `truncate` span clips
  // nothing and overflowed into the badges beside it.
  if (text.length <= tail * 2 + 4) return <span className={cn('block truncate', className)} title={title}>{text}</span>;
  return (
    <span className={cn('flex min-w-0', className)} title={title} data-middle-truncate="">
      <span className="min-w-0 overflow-hidden text-ellipsis whitespace-pre">{text.slice(0, -tail)}</span>
      <span className="shrink-0 whitespace-pre">{text.slice(-tail)}</span>
    </span>
  );
}
